exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.VuePassword__Message {\n  font-size: 0.8rem !important;\n}\n", ""]);

// exports
